import { Color } from '@/components/portfolio/components/sharedTypes'
import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import {
  CarteVisite,
  Image1,
  Image2,
  Logo,
  Pattern,
  Post1,
  Post2,
  Post3,
  Post4,
  Post5,
  Post6,
  ShootDA,
  ShootDA2,
  ShootLS,
  ShootLS2,
  Site,
  StoriesTemplate
} from './assets'

export const home: clientHomeData = {
  slug: 'dimitri-lismay',
  name: 'Dimitri Lismay',
  types: ['Identité de marque', 'Identité visuelle', 'Shooting direction artistique', 'Stratégie de marque'],
  image: CarteVisite
}

const detailed: clientPageData = {
  seo: {
    title: 'Dimitri Lismay',
    description: 'Découvrez notre travail avec Dimitri Lismay.'
  },
  blocks: [
    {
      id: 1,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        types: home.types,
        titleColor: Color.yellow,
        images: [Image1, Image2],
        urls: {
          website: 'https://www.dimitrilismay.com/',
          instagram: 'https://www.instagram.com/dimitri_lismay/'
        },
        subtitle: 'La marque'
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.imageGrid,
      props: {
        title: 'La marque',
        description: {
          cols: 2,
          content: [
            "C'est tout naturellement que Dimitri Lismay est entré dans le monde de la haute joaillerie. En suivant les traces de son père diamantaire, il a acquis son expérience sur le terrain pour devenir aujourd'hui une personne de référence dans l'univers des pierres précieuses.",
            "Entouré d'une équipe prête à réaliser des bijoux d'exception, il propose des créations  sur-mesure. Mais il propose aussi des rénovations de bijoux anciens avec comme point commun l'accompagnement personnalisé dans l'imagination du bijou. Du choix de la pierre chez les grossistes à la remise en main propre, Dimitri Lismay est l'ami qui vous permettra de trouver la perfection, grâce à ses bons conseils."
          ]
        },
        images: [],
        variant: 0,
        rightPadding: true
      }
    },
    {
      id: 3,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: Logo,
        width: 26,
        reversed: true,
        title: 'Notre travail',
        description:
          "Ce projet très complet a fait appel à (presque) tous les services proposés par l'agence ! C'est en effet pour lancer la marque qui porte son nom que le bijoutier a fait appel à nous. Nous avons donc commencé par déterminer l'identité de marque pour ensuite créer un logo qui soit en adéquation avec le storytelling développé."
      }
    },
    {
      id: 4,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: Pattern,
        width: 27,
        reversed: true,
        description:
          "Atelier Milky a ensuite décliné cette nouvelle identité sur différents supports. Que ce soit l'identité pour les réseaux sociaux, les documents officiels mais aussi le site web, nous avons travaillé afin de proposer à notre client un projet 360° !"
      }
    },
    {
      id: 5,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: CarteVisite,
        width: 39.4,
        subtitle: 'le positionnement et les supports graphiques',
        description:
          "L'entièreté de l'image de marque est basée sur le positionnement imaginé pour Dimitri Lismay : “Une dualité assumée”. La joallerie est souvent caractérisée comme carrée et froide. Mais grâce à ses conseils, à sa disponibilité et sa passion, Dimitri arrondit les angles et réchauffe cet univers."
      }
    },
    {
      id: 6,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: StoriesTemplate,
        width: 30,
        description:
          "Dans chaque support graphique cette dualité est représentée à travers les formes. Le rectangle avec ses lignes droits et ses angles représente l'inaccessibilité et la froideur tandis que le rond fait opposition en représentant la chaleur, la bienveillance et le partage."
      }
    },
    {
      id: 7,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 3,
        mobileCols: 2,
        ratio: 1,
        images: [Post1, Post2, Post3, Post4, Post5, Post6]
      }
    },
    {
      id: 8,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 1,
        mobileCols: 1,
        ratio: Site.height / Site.width,
        images: [Site]
      }
    },
    {
      id: 9,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 2,
        images: [ShootLS, ShootLS2, ShootDA, ShootDA2],
        description: {
          cols: 2,
          content: [
            "Qui dit projet complet dit forcément shooting photo ! Dimitri Limsay a également fait appel à nous afin de réaliser un shooting avec direction artistique. C'est donc en se basant sur son positionnement que nous avons imaginé un shooting contrasté au style bien marqué.",
            'Afin de lancer la marque comme il se doit, Atelier Milky a aussi imaginé une stratégie de lancement ! Instagram, Facebook, Pinterest, nous avons développé une stratégie globale pour un lancement réussi.'
          ]
        }
      }
    }
  ]
}

export default detailed
